const FAVICON_ID = 'favicon';
const SIZE = 64;

let version = 0;

const getLink = () => document.getElementById(FAVICON_ID);

/**
 * Dibuja la imagen dentro de un cuadro transparente (sin deformarla) para que
 * logotipos horizontales también se vean bien como icono de pestaña.
 * @param {string} src
 * @returns {Promise<string|null>} data URL PNG (o `src` si el canvas no se puede exportar)
 */
const aCuadrado = (src) => new Promise((resolve) => {
  const img = new Image();
  img.onload = () => {
    try {
      const canvas = document.createElement('canvas');
      canvas.width = SIZE;
      canvas.height = SIZE;
      const ctx = canvas.getContext('2d');
      const ratio = Math.min(SIZE / img.width, SIZE / img.height);
      const w = img.width * ratio;
      const h = img.height * ratio;
      ctx.drawImage(img, (SIZE - w) / 2, (SIZE - h) / 2, w, h);
      resolve(canvas.toDataURL('image/png'));
    } catch (err) {
      // Imagen remota sin CORS: no se puede exportar el canvas, se usa tal cual.
      resolve(src);
    }
  };
  img.onerror = () => resolve(null);
  img.src = src;
});

const restaurar = (link) => {
  const { defaultHref, defaultType } = link.dataset;
  link.setAttribute('type', defaultType || 'image/x-icon');
  link.setAttribute('href', defaultHref);
};

/**
 * Cambia el icono de la pestaña por el logotipo recibido.
 * Si `src` viene vacío, restaura el icono por defecto de `public/index.html`.
 * @param {string|null|undefined} src
 */
export const setFavicon = async (src) => {
  const link = getLink();
  if (!link) return;
  if (!link.dataset.defaultHref) {
    link.dataset.defaultHref = link.getAttribute('href');
    link.dataset.defaultType = link.getAttribute('type') || '';
  }
  version += 1;
  const current = version;
  if (!src) {
    restaurar(link);
    return;
  }
  const dataUrl = await aCuadrado(src);
  if (current !== version) return; // llegó una llamada más reciente
  if (!dataUrl) {
    restaurar(link);
    return;
  }
  link.setAttribute('type', 'image/png');
  link.setAttribute('href', dataUrl);
};

export default setFavicon;
